import styled from 'styled-components';
import {
  flexbox,
  flexDirection,
  alignItems,
  justifyContent
} from '../../../styles/helpers/flexbox';

const Wrapper = styled.span`
  ${flexbox()};
  ${flexDirection('column')};

  box-sizing: border-box;
  font-size: 12px;
  position: sticky;
  top: 2px;
  background-color: #c3d5e1;
  width: 54px;
  min-width: 54px;
  min-height: 190px;
  max-height: 190px;
  @media screen and (max-width: 1100px) {
    min-height: 180px;
    max-height: 180px;
  }
  z-index: 2;
`;

const Icon = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('center')};

  cursor: pointer;
`;

const Collapse = styled.div`
  ${flexbox()};
  ${alignItems('center')};
  ${justifyContent('center')};

  cursor: pointer;
  height: 40px;

  [class^='svgIconComponent'] {
    width: 23px !important;
  }

  &:hover {
    path {
      fill: #3b4e5e !important;
    }
  }
`;

const Content = styled.span((props) => {
  const { colours } = props.theme;

  return `
      ${flexbox()};
      ${flexDirection('column')};
  
      color: ${colours.grey[800]};
      width: 120px;
      height: 100px;
      transform: rotate(270deg);
      margin-top: 10px;
      cursor: pointer;
  `;
});

const TopicName = styled.div((props) => {
  const { palette } = props.theme;

  return `
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
      color: ${palette.primary.dark};
  `;
});

const Info = styled.div`
  ${flexbox()};
  ${justifyContent('space-between')};
  ${flexDirection('column')};

  height: 150px;
`;

export { Wrapper, Icon, Content, Collapse, TopicName, Info };



// WEBPACK FOOTER //
// ./components/topic/collapsed/styled.js